import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as settings from "../../lib/api-constant";
import { Observable, Subscriber } from "rxjs";
import { DndPortalPoint } from '../../lib/api-constant';
import { StorageService } from '../storage/storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserPortalService {

  constructor(protected http: HttpClient,protected storageService:StorageService) { }

  getUser() {
    const token = this.storageService.getItem('token');
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
    });
    return this.http.get(environment.ump_endpoint_url+"/"+DndPortalPoint.UserApi.GET_CURRENT_USER, { headers });
  }

  isPasswordExpired() {
    const token = this.storageService.getItem('token');
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
    });
    return this.http.get(environment.ump_endpoint_url+"/"+DndPortalPoint.UserApi.IS_PASSWORD_EXPIRED, { headers });
  }

  isAppPermitted() {
    const token = this.storageService.getItem('token');
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
    });
    return this.http.get(environment.ump_endpoint_url+"/"+DndPortalPoint.UserApi.IS_APP_PERMITTED, { headers });
  }

  validateEula(body: any = {}) {
    let url = DndPortalPoint.UserApi.EULA_VALIDATE;
    return this.http.post<any>(url, body);
  }

  
}
